<template>
  <div>
    <v-textarea
      id="maintainNote"
      ref="textField"
      v-model="internalValue.note"
      :autofocus="$attrs.autofocus"
      :disabled="$attrs.disabled"
      :required="$attrs.required"
      auto-grow
      dense
      clearable
      class="font-weight-medium text-body-1"
      :rules="prepRules()"
      @focus="onFocus"
      @blur="onBlur(internalValue)"
    >
      <template v-slot:label>
        <v-icon
          v-if="$attrs.required"
          class="required-icon"
          x-small
        >
          mdi-asterisk
        </v-icon>
        {{ $attrs.label }}
      </template>
    </v-textarea>
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Note',

    props: {
      value: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        internalValue: this.value,
      }
    },

    computed: {
      ...mapGetters('app', [
        'getDataById',
      ]),
      appRules: get('app/rules'),
    },

    watch: {
      internalValue: {
        handler (val, oldVal) {
          if (val.note === oldVal.note) return

          this.$emit('input', this.internalValue)
        },
        deep: true,
      },
      value: {
        handler (val, oldVal) {
          if (val.note === oldVal.note) return

          this.internalValue = val
        },
        deep: true,
      },
    },

    methods: {
      prepareToUpdate (dataItem) {
        if (!dataItem.updated) {
          const originalData = this.getDataById(this.$attrs.originalData, dataItem.id)
          if (originalData.length > 0) {
            if (dataItem.note !== originalData[0].note) {
              this.$store.dispatch('user/setStateAsUpdated', dataItem)
            }
          }
        }
        this.$nextTick(() => {
          this.$emit('change', dataItem)
        })
      },

      onFocus (evt) {
        evt.target.select()
      },

      selectAll () {
        // this.$refs.textField.focus()
        document.getElementById('maintainNote').focus()
        // document.getElementById('maintainNote').select()
      },

      onBlur (dataItem) {
        this.prepareToUpdate(dataItem)
      },

      prepRules () {
        if (this.$attrs.required && !this.$attrs.disabled) {
          return [this.appRules.required]
        } else {
          return []
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .required-icon {
    vertical-align: top;
    color: #dd0000;
  }
</style>
